import type { BookingDetailsState, EditPreferencesFormValues } from '../../domain/types'

export function getCanEditPreferences(state: BookingDetailsState, isEditFeatureEnabled: boolean): boolean {
  return isEditFeatureEnabled && state.isSelfServiceEnabled
}

export function getIsPreferencesSectionVisible(state: BookingDetailsState, isEditFeatureEnabled: boolean): boolean {
  return state.preferences.length > 0 || getCanEditPreferences(state, isEditFeatureEnabled)
}

export function getIsEditPreferencesLoading(state: BookingDetailsState): boolean {
  const { loadStatus } = state.editPreferences

  return loadStatus === 'idle' || loadStatus === 'loading'
}

export function getCanSavePreferences(state: BookingDetailsState): boolean {
  const { loadStatus, submitStatus, items } = state.editPreferences

  return loadStatus === 'success' && submitStatus !== 'loading' && items.length > 0
}

export function getEditPreferencesFormValues(state: BookingDetailsState): EditPreferencesFormValues {
  return {
    preferences: state.editPreferences.items.map(({ id, isSelected, customerInput }) => ({
      id,
      isSelected,
      customerInput,
    })),
  }
}
